import { ClaimStatusBadge } from "../../shared-components/claim-status-badge/ClaimStatusBadge.tsx";
import { mapToClaimAdjustmentBadgeProps } from "../../shared-components/claim-status-badge/utils.tsx";

interface ClaimAdjustmentStatusBadgeProps {
  code: string;
}

export const ClaimAdjustmentStatusBadge: React.FC<
  ClaimAdjustmentStatusBadgeProps
> = ({ code }) => {
  return (
    <ClaimStatusBadge
      mapToBadgeProps={mapToClaimAdjustmentBadgeProps}
      status={code}
    />
  );
};
